// src/config/api.js

const BASE_URL = 'https://bdvwmmdibr.us-east-1.awsapprunner.com/api/v1'; // Replace with your actual backend URL

export { BASE_URL };